module.exports = __webpack_public_path__ + "img/appleplay.34a8e1a9.png";